module.exports = __webpack_public_path__ + "static/media/Meet-The-Speakers-At-CX-NXT-UAE.13f311b4.jpeg";